import { createFileRoute } from "@tanstack/react-router";
import ServicePage from "@/pages/ServicePage";
import { getService } from "@/data/services";
import { groupACities, serviceAreaCities } from "@/data/serviceAreas";
import { canonicalUrl, pageHead } from "@/lib/site";

export const Route = createFileRoute("/services/$slug")({
  head: ({ params }) => {
    const service = getService(params.slug);
    if (!service) return {};
    const url = canonicalUrl(`/services/${service.slug}`);
    const cities =
      service.slug === "weed-control" ? serviceAreaCities : groupACities;
    const serviceSchema = {
      "@context": "https://schema.org",
      "@type": "Service",
      name: service.name,
      serviceType: service.name,
      description: service.metaDescription,
      url,
      provider: {
        "@type": "LocalBusiness",
        name: "Scotty's Land Specialist LLC",
        telephone: "+18014003346",
        url: canonicalUrl("/"),
      },
      areaServed: cities.map((city) => ({
        "@type": "City",
        name: `${city.name}, Utah`,
      })),
    };
    return {
      ...pageHead(
        service.seoTitle,
        service.metaDescription,
        `/services/${service.slug}`,
      ),
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(serviceSchema),
        },
      ],
    };
  },
  component: ServicePage,
});
